// IVA helpers (México, tasa fija 16%)
export const IVA_RATE = 0.16;

/**
 * Desglosa un monto en subtotal + IVA + total.
 * @param {number} total - Monto total.
 * @param {boolean} ivaIncluded - Si el precio ya incluye IVA (default true) o no (exento).
 * @returns {{subtotal:number, iva:number, total:number, hasIva:boolean, ivaRate:number}}
 */
export function computeIVA(total, ivaIncluded = true) {
  const t = Number(total || 0);
  if (!ivaIncluded) {
    return { subtotal: t, iva: 0, total: t, hasIva: false, ivaRate: IVA_RATE };
  }
  const subtotal = Math.round((t / (1 + IVA_RATE)) * 100) / 100;
  const iva = Math.round((t - subtotal) * 100) / 100;
  return { subtotal, iva, total: t, hasIva: true, ivaRate: IVA_RATE };
}

/**
 * Formatea un monto en MXN.
 */
export function fmtMXN(n) {
  return `$${Number(n || 0).toFixed(2)}`;
}
